module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp123_8023.7d2bae4b.png";